import React, { useState, useEffect } from "react";
import "./PaymentModal.scss";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import {
  getProfile,
  createLandlordPayment,
  fetchPayments,
  listInvoicesUnpaid,
  createSTK,
  checkSTKStatus,
} from "../../redux/slices/sliceActions";

// Import custom toasts
import customToasts from "../assets/reusableComponents/myToasts";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";

const PaymentModal = ({
  isOpen,
  closeModal,
  defaultValues = {},
  fieldsToShow = [],
  selectedApartmentId,
}) => {
  const [marginTopSet, setMarginTopSet] = useState("10vh");

  useEffect(() => {
    console.log("defaultValues", defaultValues);
  }, [defaultValues]);

  useEffect(() => {
    if (fieldsToShow.length === 1) {
      setMarginTopSet("20vh");
    }
  }, [fieldsToShow]);

  //user data
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const id = user?.data?.user?.user_id;

  console.log("default values", defaultValues);
  const [paymentDetails, setPaymentDetails] = useState({
    house_id: defaultValues?.house_id || "",
    house_no: defaultValues?.house_no || "",
    rent: defaultValues?.rent || "",
    water: defaultValues?.water || "",
    arrears: defaultValues?.arrears || "",
    serviceCharge: defaultValues?.serviceCharge || "",
    unpaidDeposit: defaultValues?.unpaidDeposit || "",
    garbage: defaultValues?.garbage || "",
    paymentMethod: defaultValues?.paymentMethod || "PAYBILL",
    phoneNumber: defaultValues?.phoneNumber || "",
    referenceNumber: defaultValues?.referenceNumber || "",
    paymentNarration: defaultValues?.paymentNarration || "",
  });

  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    setPaymentDetails({
      rent: defaultValues?.rent || "",
      water: defaultValues?.water || "",
      arrears: defaultValues?.arrears || "",
      serviceCharge: defaultValues?.serviceCharge || "",
      unpaidDeposit: defaultValues?.unpaidDeposit || "",
      garbage: defaultValues?.garbage || "",
      paymentMethod: defaultValues?.paymentMethod || "PAYBILL",
      phoneNumber: defaultValues?.phoneNumber || "",
      referenceNumber: defaultValues?.referenceNumber || "",
      paymentNarration: defaultValues?.paymentNarration || "",
      month: defaultValues?.month || "",
      year: defaultValues?.year || "",
    });
    setLoading(false);
    setComplete(false);
  }, [defaultValues]);

  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    const total = fieldsToShow.reduce((sum, field) => {
      return sum + Number(paymentDetails[field] || 0);
    }, 0);
    setTotalAmount(total);
  }, [paymentDetails, fieldsToShow]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    const val = type === "number" ? (value ? parseInt(value, 10) : "") : value;
    setPaymentDetails({ ...paymentDetails, [name]: val });
  };

  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentMonth = currentDate.getMonth() + 1; // Months are zero-indexed
  const currentYear = currentDate.getFullYear();

  const [selectedDate, setSelectedDate] = useState(currentDay);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const handleDateSelect = (e) => {
    const { name, value } = e.target;
    const parsedValue = parseInt(value, 10);

    if (name === "date") {
      setSelectedDate(parsedValue);
    } else if (name === "month") {
      setSelectedMonth(parsedValue);
    } else if (name === "year") {
      setSelectedYear(parsedValue);
    }
  };

  function formatDate(year, month, day) {
    // Pad month and day with leading zeros if they are less than 10
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");

    // Return the formatted date as YYYY-MM-DD
    return `${year}-${formattedMonth}-${formattedDay}`;
  }

  const [paymentDate, setPaymentDate] = useState("");

  useEffect(() => {
    const formatedDate = formatDate(selectedYear, selectedMonth, selectedDate);
    setPaymentDate(formatedDate);
  }, [selectedDate, selectedMonth, selectedYear]);

  //submit payment
  const [submissionState, setSubmissionState] = useState("idle"); // 'idle', 'loading', 'complete', 'failed'
  const [failureMessage, setFailureMessage] = useState(
    "Payment was not completed. Please try again or contact support."
  );
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: Check for negative values
    const valuesToCheck = fieldsToShow.filter((field) => {
      const value = Number(paymentDetails[field] || 0);
      return value < 0;
    });

    if (valuesToCheck.length > 0) {
      const fieldNames = valuesToCheck
        .map((field) => {
          const fieldDisplayNames = {
            rent: "Rent",
            water: "Water",
            arrears: "Arrears",
            serviceCharge: "Service Charge",
            unpaidDeposit: "Unpaid Deposit",
            garbage: "Garbage",
          };
          return fieldDisplayNames[field] || field;
        })
        .join(", ");

      customToasts.error(`Negative values are not allowed for: ${fieldNames}`);
      return; // Prevent form submission
    }

    // Additional validation: Check if total amount is zero or negative
    if (totalAmount <= 0) {
      customToasts.error("Total payment amount must be greater than zero");
      return;
    }

    setSubmissionState("loading");

    const newPaymentDetails = {
      house_id: defaultValues?.house_id || 0,
      houseNumber: defaultValues?.house_no || "",
      method: paymentDetails.paymentMethod || "CASH",
      narration: paymentDetails.paymentNarration || "",
      reference: paymentDetails.referenceNumber || "",
      payment_date: paymentDate,
      month: selectedMonth || "",
      year: selectedYear || "",
      rent: paymentDetails.rent || 0,
      water: paymentDetails.water || 0,
      garbage: paymentDetails.garbage || 0,
      service_charge: paymentDetails.serviceCharge || 0,
      late_fee: paymentDetails.lateFee || 0,
      arrears: paymentDetails.arrears || 0,
      unpaid_deposit: paymentDetails.unpaidDeposit || 0,
    };

    try {
      // Check if payment method is STK (TILLNO)
      if (paymentDetails.paymentMethod === "TILLNO") {
        console.log("payment method is STK_PUSH");
        const stkResponse = await dispatch(
          createSTK({
            paymentDetails: {
              house_id: newPaymentDetails?.house_id,
              narration: newPaymentDetails?.narration,
              month: newPaymentDetails?.month,
              year: newPaymentDetails?.year,
              rent: newPaymentDetails?.rent,
              water: newPaymentDetails?.water,
              garbage: newPaymentDetails?.garbage,
              service_charge: newPaymentDetails?.service_charge,
              late_fee: newPaymentDetails?.late_fee,
              arrears: newPaymentDetails?.arrears,
              unpaid_deposit: newPaymentDetails?.unpaid_deposit,
              phone: paymentDetails?.phoneNumber,
            },
          })
        );

        console.log("STK Response", stkResponse);

        // Extract checkout request ID and start polling
        const checkoutRequestId = stkResponse?.payload?.data?.checkoutRequestId;

        if (checkoutRequestId) {
          console.log(
            "Starting polling for checkout request:",
            checkoutRequestId
          );

          // Start polling for payment status
          const pollInterval = setInterval(async () => {
            try {
              const response = await dispatch(
                checkSTKStatus({ checkoutRequestId })
              );
              console.log("Polling response:", response);

              const responseData = response?.payload?.data;
              const isCompleted = responseData?.isCompleted;
              const isFailed = responseData?.isFailed;
              const isExpired = responseData?.isExpired;
              const shouldStopPolling = responseData?.shouldStopPolling;
              const payment = responseData?.payment;
              const failureReason = responseData?.failureReason;

              // Stop polling if the API indicates we should stop
              if (shouldStopPolling === true) {
                clearInterval(pollInterval);

                if (isCompleted === true && payment) {
                  // Payment successful
                  console.log("Payment successful!", payment);
                  setSubmissionState("complete");

                  // Refresh data
                  dispatch(
                    fetchPayments({
                      propertyId: selectedApartmentId,
                      month: selectedMonth,
                      year: selectedYear,
                    })
                  );
                  dispatch(
                    listInvoicesUnpaid({
                      property_id: selectedApartmentId,
                      selectedMonth,
                      selectedYear,
                    })
                  );

                  // Close modal after showing success
                  setTimeout(() => {
                    closeModal();
                    setSubmissionState("idle");
                  }, 3000);
                } else if (isFailed === true || isExpired === true) {
                  // Payment failed, expired, or was cancelled
                  console.log(
                    "Payment failed:",
                    failureReason || "Payment was not completed"
                  );
                  setFailureMessage(
                    failureReason ||
                      "Payment was not completed. Please try again or contact support."
                  );
                  setSubmissionState("failed");
                } else {
                  // Other failure scenarios
                  console.log("Payment failed or cancelled");
                  setFailureMessage(
                    "Payment was not completed. Please try again or contact support."
                  );
                  setSubmissionState("failed");
                }
              }
              // If shouldStopPolling is false, continue polling (payment still pending)
            } catch (error) {
              console.error("Polling error:", error);
              clearInterval(pollInterval);
              setSubmissionState("failed");
            }
          }, 5000); // Poll every 5 seconds

          // Set a timeout to stop polling after 5 minutes
          setTimeout(() => {
            clearInterval(pollInterval);
            if (submissionState === "loading") {
              console.log("Polling timeout - payment took too long");
              setSubmissionState("failed");
            }
          }, 300000); // 5 minutes timeout
        } else {
          console.error("No checkout request ID received from STK response");
          setSubmissionState("failed");
        }
      } else {
        // Handle other payment methods - use the original method
        await dispatch(
          createLandlordPayment({
            propertyId: selectedApartmentId,
            details: newPaymentDetails,
          })
        ).then((res) => {
          console.log("selectedApartmentId", selectedApartmentId);
          console.log("Payment creation response", res);
          if (res?.payload?.status !== "success") {
            setSubmissionState("failed");
            setFailureMessage(
              res?.payload?.message ||
                "Payment creation failed. Please try again or contact support."
            );
            throw new Error("Payment creation failed");
          }
          dispatch(
            fetchPayments({
              propertyId: selectedApartmentId,
              month: selectedMonth,
              year: selectedYear,
            })
          );
          dispatch(
            listInvoicesUnpaid({
              property_id: selectedApartmentId,
              selectedMonth,
              selectedYear,
            })
          ).then((res) => {
            console.log("unpaid invoices", res);
          });
        });

        setSubmissionState("complete");
        setTimeout(() => {
          closeModal();
          setSubmissionState("idle");
        }, 2000);
      }
    } catch (error) {
      console.error("Payment submission failed", error);
      setSubmissionState("failed");
      setTimeout(() => {
        setSubmissionState("idle");
      }, 5000);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div
        className="modal-content"
        style={{ marginTop: `${marginTopSet}` }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pay-window-title">Make a Payment</div>

        {submissionState === "loading" ? (
          <div className="loading-container">
            <div className="loader"></div>
            {paymentDetails.paymentMethod === "TILLNO" && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  fontSize: "14px",
                  color: "#666",
                }}
              >
                Please complete the payment on your phone. Waiting for
                confirmation...
              </div>
            )}
          </div>
        ) : submissionState === "complete" ? (
          <div className="complete-container">
            <div
              className="complete-animation"
              style={{ color: "#28a745", fontSize: "18px", fontWeight: "bold" }}
            >
              Payment Successful!
            </div>
            <div
              style={{
                textAlign: "center",
                color: "#28a745",
                marginTop: "10px",
                fontSize: "14px",
              }}
            >
              Your payment has been processed successfully.
            </div>
          </div>
        ) : submissionState === "failed" ? (
          <div
            className="failed-container"
            style={{ textAlign: "center", padding: "20px" }}
          >
            <div
              style={{
                color: "#dc3545",
                fontSize: "18px",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              Payment Failed
            </div>
            <div
              style={{
                color: "#dc3545",
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              {failureMessage}
            </div>
            <div style={{ display: "flex" }}>
              <button
                type="button"
                className="submit-btn"
                onClick={() => setSubmissionState("idle")}
                style={{ marginRight: "10px" }}
              >
                Try Again
              </button>
              <button type="button" className="close-btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {/* Payment Method Selection */}
            <div style={{ display: "flex", gap: "10px" }}>
              <div className="form-group">
                <label htmlFor="paymentMethod">Payment Method:</label>
                <select
                  id="paymentMethod"
                  name="paymentMethod"
                  value={paymentDetails.paymentMethod}
                  onChange={handleChange}
                >
                  <option value="PAYBILL">M-Pesa</option>
                  <option value="TILLNO">Lipa Na Mpesa STK</option>
                  <option value="BANK_TRANSFER">Bank Transfer</option>
                  <option value="CASH">Cash</option>
                </select>
              </div>

              {/* Conditionally render fields based on payment method */}
              {paymentDetails.paymentMethod === "TILLNO" && (
                <div className="form-group">
                  <label htmlFor="phoneNumber">Phone Number:</label>
                  <input
                    type="text"
                    id="phoneNumber"
                    name="phoneNumber"
                    value={paymentDetails.phoneNumber}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}

              {["PAYBILL", "BANK_TRANSFER", "M-Pesa"].includes(
                paymentDetails.paymentMethod
              ) && (
                <div className="form-group">
                  <label htmlFor="referenceNumber">Reference Number:</label>
                  <input
                    type="text"
                    id="referenceNumber"
                    name="referenceNumber"
                    value={paymentDetails.referenceNumber}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "5px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "5px",
                  width: "100%",
                }}
              >
                <div className="form-group">
                  <label htmlFor="date">Day</label>
                  <select
                    id="date"
                    name="date"
                    value={selectedDate}
                    onChange={handleDateSelect}
                    required
                  >
                    {[...Array(31).keys()].map((day) => (
                      <option key={day + 1} value={day + 1}>
                        {day + 1}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="month">Month</label>
                  <select
                    id="month"
                    name="month"
                    value={selectedMonth}
                    onChange={handleDateSelect}
                    required
                  >
                    {[
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ].map((month, index) => (
                      <option key={index + 1} value={index + 1}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="year">Year</label>
                  <select
                    id="year"
                    name="year"
                    value={selectedYear}
                    onChange={handleDateSelect}
                    required
                  >
                    {Array.from({ length: 11 }, (_, i) => 2020 + i).map(
                      (year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
            </div>

            {/* Payment Narration Field */}
            <div className="form-group">
              <label htmlFor="paymentNarration">Payment Narration:</label>
              <input
                type="text"
                id="paymentNarration"
                name="paymentNarration"
                value={paymentDetails.paymentNarration}
                onChange={handleChange}
              />
            </div>

            {/* Dynamically render fields based on fieldsToShow prop */}

            <div style={{ display: "flex", gap: "10px" }}>
              {fieldsToShow.includes("rent") && (
                <div className="form-group">
                  <label htmlFor="rent">Rent:</label>
                  <input
                    type="number"
                    id="rent"
                    name="rent"
                    value={paymentDetails.rent}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}

              {fieldsToShow.includes("water") && (
                <div className="form-group">
                  <label htmlFor="water">Water:</label>
                  <input
                    type="number"
                    id="water"
                    name="water"
                    value={paymentDetails.water}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              {fieldsToShow.includes("arrears") && (
                <div className="form-group">
                  <label htmlFor="arrears">Arrears:</label>
                  <input
                    type="number"
                    id="arrears"
                    name="arrears"
                    value={paymentDetails.arrears}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}

              {fieldsToShow.includes("serviceCharge") && (
                <div className="form-group">
                  <label htmlFor="serviceCharge">Service Charge:</label>
                  <input
                    type="number"
                    id="serviceCharge"
                    name="serviceCharge"
                    value={paymentDetails.serviceCharge}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              {fieldsToShow.includes("unpaidDeposit") && (
                <div className="form-group">
                  <label htmlFor="unpaidDeposit">Unpaid Deposit:</label>
                  <input
                    type="number"
                    id="unpaidDeposit"
                    name="unpaidDeposit"
                    value={paymentDetails.unpaidDeposit}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}

              {fieldsToShow.includes("garbage") && (
                <div className="form-group">
                  <label htmlFor="garbage">Garbage:</label>
                  <input
                    type="number"
                    id="garbage"
                    name="garbage"
                    value={paymentDetails.garbage}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}
            </div>

            {/* display total ammount */}
            <div
              className="form-group"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div style={{ fontSize: "20px" }}>
                Total Amount: ksh {totalAmount}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button type="submit" className="submit-btn">
                Submit Payment
              </button>
              <button type="button" className="close-btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </form>
        )}
      </div>

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
};

export default PaymentModal;
